<template>
  <div v-if="user" class="w-full h-full">
    <Header :expand="expand" :user="user" :title="route" @toggleMenu="toggleMenu" />
    <Navigation
      :expand="expand"
      :user="user"
      :title="route"
      @toggleMenu="toggleMenu"
      @openChangelog="openChangelog"
      ref="nav"
    />
    <div id="content" class="w-full h-full pt-20" :class="expand ? 'pl-64' : 'md:pl-16'">
      <div class="w-full h-full p-4">
        <Dashboard :user="user" v-if="route === 'Home' && user.Dashboard > 0" />
        <HomeNavigation :user="user" v-else-if="route === 'Home'" />
        <Attendance :user="user" v-if="route === 'Anwesenheit' && user.Attendance > 0" />
        <MealPlanning :user="user" v-if="route === 'Essensplanung' && user.Mealplan > 0" />
        <Export :user="user" v-if="route === 'Exporte' && user.Exporte > 0" />
        <DataTable type="Contracts" :user="user" v-if="route === 'Verträge' && (user.Contracts > 0 || user.restrictedViews)" />
        <DataTable type="Customers" :user="user" v-if="route === 'Kunden' && (user.Customers > 0 || user.restrictedViews)" />
        <DataTable type="Projects" :user="user" v-if="route === 'Projekte' && (user.Projects > 0 || user.restrictedViews)" />
        <DataTable type="Contacts" :user="user" v-if="route === 'Kontakte' && user.Contacts > 0" />
        <DataTable type="Polls" :user="user" v-if="route === 'Umfragen' && user.Umfragen > 0" />
        <DistributionLists :user="user" v-if="route === 'Verteiler' && user.Maillist > 0" />
        <DataTable type="Employees" :user="user" v-if="route === 'Mitarbeiter' && user.Employees > 0" />
        <Announcements :user="user" v-if="route === 'Ankündigungen' && user.Announcements > 0" />
        <AccountHelp :user="user" v-if="route === 'Accounthilfe' && user.Accounts > 0" />
        <Permissions :user="user" v-if="route === 'Berechtigungen' && user.Permissions > 0" />
        <CsvImport :user="user" v-if="route === 'Import' && user.Import > 0" />
        <Maintenance :user="user" v-if="route === 'Wartungsmodus' && user.Maintenance > 0" />
        <ContractEdit :user="user" v-if="route === 'ContractEdit'" />
      </div>
    </div>
    <ChangelogModal
      v-if="showChangelog"
      :version="changelog.version"
      :markdown="changelog.markdown"
      @dismiss="dismissChangelog"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Navigation from '@/components/Navigation.vue'
import HomeNavigation from '@/components/HomeNavigation.vue'
import Dashboard from '@/components/Dashboard.vue'
import Attendance from '@/components/Attendance.vue'
import MealPlanning from '@/components/Mealplanning.vue'
import Export from '@/components/Export.vue'
import DataTable from '@/components/DataTable.vue'
import ContractEdit from '@/components/ContractEdit.vue'
import DistributionLists from '@/components/DistributionLists.vue'
import Announcements from '@/components/Announcements.vue'
import AccountHelp from '@/components/AccountHelp.vue'
import Permissions from '@/components/Permissions.vue'
import CsvImport from '@/components/CsvImport.vue'
import Maintenance from '@/components/Maintenance.vue'
import ChangelogModal from '@/components/ChangelogModal.vue'
import API from '@/API'
import changelog from '@/generated/changelog.json'
import {
  dismissChangelog as persistChangelogDismissal,
  getChangelogDismissalKey,
  isEligibleIntern,
  shouldShowChangelog,
} from '@/admin/changelogVisibility'
export default {
  name: 'HomeView',
  components: {
    Navigation,
    Header,
    Attendance,
    Dashboard,
    HomeNavigation,
    MealPlanning,
    Export,
    DataTable,
    ContractEdit,
    DistributionLists,
    Announcements,
    AccountHelp,
    Permissions,
    CsvImport,
    Maintenance,
    ChangelogModal
  }, data() {
    return {
      route: this.$router.currentRoute.value.name,
      user: null,
      expand: true,
      changelog,
      showChangelog: false,
    }
  },
  computed: {
    canOpenChangelog() {
      return isEligibleIntern(this.user)
    },
  },
  methods: {
    toggleMenu() {
      this.expand = !this.expand
    },
    getLocalStorage() {
      try {
        return typeof window === "undefined" ? null : window.localStorage
      } catch (_error) {
        return null
      }
    },
    openChangelog() {
      if (this.canOpenChangelog) {
        this.showChangelog = true
      }
    },
    dismissChangelog() {
      if (this.canOpenChangelog) {
        persistChangelogDismissal(
          this.getLocalStorage(),
          getChangelogDismissalKey(this.changelog.version, this.user.id)
        )
      }
      this.showChangelog = false
    },
    maybeOpenChangelog() {
      if (
        this.canOpenChangelog &&
        shouldShowChangelog(
          this.user,
          this.changelog.version,
          this.getLocalStorage()
        )
      ) {
        this.showChangelog = true
      }
    }
  },
  watch: {
    $route(to) {
      this.route = to.name
    }
  },
  created() {
    API.checkAuth((r, status) => {
      if (status === 200) {
        this.user = r
        if (!this.user.Intern) {
          if (process.env.NODE_ENV === "development") {
            console.log("Not an intern, redirecting to mein URL");
          } else {
            window.location = process.env.VUE_APP_MEIN_URL
          }
        } else {
          this.maybeOpenChangelog()
        }
      } else if (status === 401) {
        window.location = process.env.VUE_APP_LOGIN_URL
      }
    })
    // dont expand if screen is small
    if (window.innerWidth < 1024) {
      this.expand = false;
    }
  }
}
</script>
